import { render } from "./SystemBillingInvoices.vue?vue&type=template&id=21c28b7c&scoped=true"
import script from "./SystemBillingInvoices.vue?vue&type=script&lang=js"
export * from "./SystemBillingInvoices.vue?vue&type=script&lang=js"

import "./SystemBillingInvoices.vue?vue&type=style&index=0&id=21c28b7c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c28b7c"]])

export default __exports__